import {EnvService} from './env.service';

export function firebaseOptionsFactory(envService: EnvService) {
  return envService.firebaseConfig;
}
